import { Bell } from 'lucide-react';
import { cn } from '../../lib/utils';

type UnreadNotificationBellProps = {
  hasUnread: boolean;
  className?: string;
};

/** Bell icon that turns fully red when there are unread notifications. */
export function UnreadNotificationBell({ hasUnread, className }: UnreadNotificationBellProps) {
  return (
    <Bell
      className={cn(
        'w-5 h-5 transition-colors',
        hasUnread ? 'text-destructive' : 'text-header-text-muted group-hover:text-primary',
        className
      )}
      aria-hidden="true"
    />
  );
}
